/**
 * App-only areas: noindex, no SSR content, no public chat bubble, no page
 * tracking. Kept apart from route-meta.ts (the 40 KB SEO manifest) so the
 * app shell can check a path without shipping every page's meta on first load.
 * route-meta.ts re-exports both names, so existing imports keep working.
 */
/** Authenticated / app-only areas: noindex, no content injection. */
export const PRIVATE_PREFIXES = [
  "/dashboard",
  "/workspace",
  "/admin",
  "/settings",
  "/plans",
  "/account",
  "/clients",
  "/projects",
  "/project",
  "/competitors",
  "/technical-analysis",
  "/competitor-analysis",
  "/competitor-results",
  "/competitor-summary",
  "/my-competitors",
  "/share-earn",
  "/analytics-admin",
  "/dev",
  "/onboarding",
  "/new-project",
  "/my-brand",
  "/analysis-results",
  "/heatmap-analysis",
  "/heatmap-results",
  "/free-cro-results",
  "/free-cro-v3/results",
  "/website-audit-results",
  "/reset-password",
  "/payment-success",
  "/checkout",
  "/shared",
  "/embed",
  "/presentation",
  "/unsubscribe",
  "/agency-interest",
  "/demo-signup",
  "/promo",
  // Special links (Admin › Special links): private offers, never indexed.
  "/offer",
  "/compare/s",
  "/api",
  // The Chrome extension's connect page and the User Agent / Funnel reports
  // (their notifications link to /agent/run/:id). Without these the edge
  // layer answered 404 "Page Not Found" before the app rendered them.
  "/extension",
  "/agent",
];

/** Is this a public, indexable app path (not a private prefix)? */
export function isPrivatePath(path: string): boolean {
  return PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
}
